import { colors, Theme, ThemeOptions } from '@mui/material';
export const alertStyles = (theme: Theme): ThemeOptions => ({
  components: {
    MuiAlert: {
      styleOverrides: {
        root: {
          padding: '0.5rem 1rem',
        },
      },
      variants: [
        {
          props: { severity: 'error', variant: 'standard' },
          style: {
            color: theme.palette.error.dark,
            backgroundColor: colors.red[50],
            '.MuiSvgIcon-root': {
              color: colors.red[400],
            },
          },
        },
        {
          props: { severity: 'warning', variant: 'standard' },
          style: {
            color: theme.palette.warning.dark,
            backgroundColor: colors.yellow[50],
            '.MuiSvgIcon-root': {
              color: colors.yellow[400],
            },
          },
        },
        {
          props: { severity: 'success', variant: 'standard' },
          style: {
            color: theme.palette.success.dark,
            backgroundColor: colors.green[50],
            '.MuiSvgIcon-root': {
              color: colors.green[400],
            },
          },
        },
        {
          props: { severity: 'info', variant: 'standard' },
          style: {
            color: theme.palette.primary.dark,
            backgroundColor: colors.blue[50],
            '.MuiSvgIcon-root': {
              color: colors.blue[400],
            },
          },
        },
        {
          props: { size: 'sm' },
          style: {
            padding: '0.25rem 1rem',
          },
        },
        {
          props: { size: 'lg' },
          style: {
            padding: '1.25rem 1.5rem',
            fontSize: '1rem',
            fontWeight: theme.typography.fontWeightMedium,
          },
        },
        {
          props: { severity: 'success', variant: 'filled' },
          style: {
            color: theme.palette.common.black,
            '.MuiSvgIcon-root': {
              color: theme.palette.common.black,
            },
          },
        },
      ],
    },
  },
});
